var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:{'disabled':_vm.lock}},[_c('div',{staticClass:"login",class:{'login_disabled':_vm.lock}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }